import { WebView, _decorator } from 'cc';
import { DEV, PREVIEW } from 'cc/env';
import BindDOMNode from './BindDOMNode';
import DOMElementAdapter from './DOMElementAdapter';

const { ccclass, property } = _decorator;

@ccclass('IFrameElementAdapter')
export default class IFrameElementAdapter extends DOMElementAdapter<HTMLIFrameElement> {
    @property({ tooltip: DEV && 'Whether to hide the scroll bar of the iframe.' })
    public readonly hideScrollBar: boolean = false;

    @property({ tooltip: DEV && 'Whether to hide the border of the iframe.' })
    public readonly hideBorder: boolean = false;

    @property({ tooltip: DEV && 'Whether to allow autoplay.' })
    public readonly autoPlay: boolean = false;

    private _useWebViewComponent: boolean = false;

    protected onLoad() {
        super.onLoad();
        // prevent iframe being covered by canvas in preview mode
        if (PREVIEW) {
            document.body.style.backgroundColor = 'transparent';
        }
    }

    protected applyPropertyOnElement(element: HTMLIFrameElement) {
        super.applyPropertyOnElement(element);

        // Set the render order of the iframe
        (this._useWebViewComponent ? element.parentElement : element).style.zIndex = this.renderOrder.toString();

        // Hide the scroll bar of the iframe
        if (this._useWebViewComponent && this.hideScrollBar) {
            element.parentElement.style.overflow = 'hidden';
        }

        // Hide the border of the iframe
        if (this.hideBorder) {
            element.style.border = 'none';
        }

        // TODO handle other allowed properties
        // Allow autoplay
        if (this.autoPlay) {
            element.allow = 'autoplay';
        }
    }

    protected findElement(): HTMLIFrameElement {
        const webView = this.getComponent(WebView);
        if (webView) {
            this._useWebViewComponent = true;
            return webView.nativeWebView;
        }
        const bindDOMNode = this.getComponent(BindDOMNode);
        if (bindDOMNode) {
            if (bindDOMNode.element instanceof HTMLIFrameElement) {
                return bindDOMNode.element as HTMLIFrameElement;
            }
            throw new Error('The element of BindDOMNode is not an HTMLIFrameElement');
        }
        throw new Error('No WebView or BindDOMNode component found');
    }
}
